import React from "react";
import { Modal, Input, Button, Form, notification } from "antd";
import { LuX, LuEye, LuEyeOff } from "react-icons/lu";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useUpdatePasswordMutation } from "../../store/api/apiSlice";
import { useSelector } from "react-redux";

export const ChangePasswordModal = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const [updatePassword, { isLoading }] = useUpdatePasswordMutation();

  const userDatas = useSelector((state) => state.auth);

  const handleSubmit = async (values) => {
    if (values.new_password !== values.confirm_password) {
      notification.error({
        message: "Error",
        description: "New passwords do not match",
      });
      return;
    }

    try {
      await updatePassword({
        current_password: values.current_password,
        isAdmin: userDatas?.role === "admin",
        new_password: values.new_password,
      }).unwrap();

      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Failed to update password:", error);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      closeIcon={
        <div className="bg-secondary h-8 w-8 flex justify-center items-center rounded-full relative top-1">
          <LuX className="text-red-400" size={20} />
        </div>
      }
      title={
        <h3 className="text-xl font-semibold relative -top-4">
          Change Password
        </h3>
      }
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <div className="space-y-6">
          <Form.Item
            name="current_password"
            label="Current Password"
            rules={[
              { required: true, message: "Current password is required" },
            ]}
          >
            <Input.Password
              placeholder="Enter current password"
              className="h-11 rounded-xl"
              prefix={<HiOutlineLockClosed className="text-2xl" size={19} />}
              iconRender={(visible) =>
                visible ? <LuEye size={19} /> : <LuEyeOff size={19} />
              }
            />
          </Form.Item>
          <Form.Item
            name="new_password"
            label="New Password"
            rules={[
              { required: true, message: "New password is required" },
              { min: 8, message: "Password must be at least 8 characters" },
            ]}
          >
            <Input.Password
              placeholder="Minimum 8 characters"
              className="h-11 rounded-xl"
              prefix={<HiOutlineLockClosed className="text-2xl" size={19} />}
              iconRender={(visible) =>
                visible ? <LuEye size={19} /> : <LuEyeOff size={19} />
              }
            />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="Confirm New Password"
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm new password"
              className="h-11 rounded-xl"
              prefix={<HiOutlineLockClosed className="text-2xl" size={19} />}
              iconRender={(visible) =>
                visible ? <LuEye size={19} /> : <LuEyeOff size={19} />
              }
            />
          </Form.Item>
          <div className="flex justify-between pt-4 gap-3">
            <Button
              onClick={onClose}
              className="px-6 py-2 border rounded-2xl w-[50%] btnSecondary text-gray-700 flex items-center gap-2"
            >
              Cancel
            </Button>
            <Button
              htmlType="submit"
              loading={isLoading}
              className="px-6 py-2 bg-[#202835] w-[50%] rounded-2xl text-white flex items-center gap-2"
            >
              Save Changes
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
